module.exports = __webpack_public_path__ + "static/media/blog-9.d4a06559.svg";